module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-netlify-cms@7.8.0_gatsby@5.8.1_netlify-cms-app@2.15.72_react-dom@18.2.0_react@18.2.0_webpack@5.77.0/node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@5.13.1_gatsby@5.8.1_graphql@15.8.0/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"./src/images/svg/icon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"2cd44c23c53efd44c5f8d4bb2a3c128d"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.8.1_babel-eslint@10.1.0_react-dom@18.2.0_react@18.2.0_typescript@5.0.3/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
